<template>
  <span>
    <v-row>
      <v-col :cols="stackHeaders ? '12' : '6'">
        <v-list-item class="pr-0">
          <v-list-item-content>
            <v-list-item-action-text class="font-weight-black">
              {{ isSubOrder ? $t('subOrder.preparation') :  $t('order.order') }} N°{{ order.order_id }}
              <span v-if="!isSuborder && this.$route.name != 'orderDetails'">
                <v-chip
                  v-if="isPaid"
                  color="green"
                  text-color="white"
                  class="d-md-table d-lg-inline-flex my-md-2 my-lg-0"
                  small
                >
                  {{ $t('subOrder.paid') }}
                </v-chip>
                <v-chip v-else color="red" text-color="white" class="d-md-table d-lg-inline-flex my-md-2 my-lg-0" small>
                  {{ $t('subOrder.unpaid') }}
                </v-chip>
              </span>
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.type">
              <span class="font-weight-black">{{ $t('order.type') }}:</span> {{ getTypeTranslation(order.type) }}
            </v-list-item-action-text>
            <v-list-item-action-text v-else-if="order.carrier && order.carrier.carrier_type">
              <span class="font-weight-black"> {{ $t('order.type') }}:</span>
              {{ getTypeTranslation(order.carrier.carrier_type) }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.origin">
              <span class="font-weight-black">{{ $t('order.orderOrigin') }}:</span> {{ order.origin }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.sub_channel">
              <span class="font-weight-black">{{ $t('order.subChannel') }}:</span> {{ order.sub_channel }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.customer.last_name && order.customer.first_name">
              <span class="font-weight-black">{{ $t('order.client') }}: </span> {{ order.customer.first_name }}
              {{ order.customer.last_name }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('order.status') }}: </span>
              <span text color="primary" @click="openHistoryDialog(order)">
                <v-badge color="secondary" inline icon="mdi-history">
                  {{ getStatusTranslation(order.current_status) }}
                </v-badge>
              </span>
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.current_status == 'cancelled' && order.cancel_reason">
              <span class="font-weight-black">{{ $t('subOrder.cancelReason') }}: </span>
              {{ getCancelReasonTranslation(order.cancel_reason) }}
            </v-list-item-action-text>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col :cols="stackHeaders ? '12' : '6'" class="text-right">
        <v-list-item class="pl-0">
          <v-list-item-content>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('order.date') }}: </span>
              {{ new Date(order.date) | moment('DD/MM/YYYY HH:mm:ss') }}
            </v-list-item-action-text>
            <v-list-item-action-text class="font-weight-black">
              {{ $t('order.products') }}: <span>{{ totalNbProductValidated }}/</span>{{ totalNbProduct }}
            </v-list-item-action-text>
            <v-list-item-action-text>
              <span class="font-weight-black">{{ $t('order.amount') }}: </span>
              {{ order.total_price | formatPrice(order.currency) }}
              {{ order.currency ? order.currency.code : order.currency_code }}
            </v-list-item-action-text>
            <v-list-item-action-text v-if="order.current_status != 'waiting_allocation'">
              <span class="font-weight-black">{{ $t('order.validatedAmount') }}: </span>
              {{ totalPriceValidated | formatPrice(order.currency) }}
              {{ order.currency ? order.currency.code : order.currency_code }}
            </v-list-item-action-text>
            <v-list-item-action-text
              v-if="order.current_status != 'waiting_allocation' && order.carrier && !order.type"
              class="text-uppercase"
            >
              <span class="font-weight-black">{{ $t('order.shippingCost') }}: </span>
              {{ getCarrierCost() | formatPrice(order.currency) }}
              {{ order.currency ? order.currency.code : order.currency_code }}
            </v-list-item-action-text>
            <v-list-item-action-text
              v-if="
                order.carrier &&
                ['home_delivery', 'relay_point_delivery', 'express_home_delivery'].includes(order.carrier.carrier_type) &&
                order.source_location_id &&
                order.current_status != 'waiting_allocation'
              "
            >
              <span class="font-weight-black">{{ $t('order.location') }}: {{ order.source_location_id }} </span>
            </v-list-item-action-text>
            <v-list-item-action-text v-else-if="order.pickup_location_id">
              <span class="font-weight-black">{{ $t('order.location') }}:</span> {{ order.pickup_location_id }}
            </v-list-item-action-text>
            <v-list-item-action-text  v-if="order.pickup_deadline && order.current_status =='to_pickup'" class="primary--text">
              <span class="font-weight-black" v-if="order.pickup_deadline">{{ $t('order.pickupDeadline') }}:
              {{ new Date(order.pickup_deadline) | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </v-list-item-action-text>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <!-- modals -->
    <order-status-history-dialog v-model="showHistoryDialog" @close="closeHistoryDialog()" :item="targetItem">
    </order-status-history-dialog>
  </span>
</template>

<script>
import OrderStatusHistoryDialog from '@/components/dialogs/StatusHistoryDialog.vue'

export default {
  name: 'OrderHeadersMobile',
  components: {
    OrderStatusHistoryDialog
  },
  data() {
    return {
      showHistoryDialog: false,
      status: [
        { text: this.$t('order.waiting'), value: 'waiting' },
        { text: this.$t('order.waitingPayment'), value: 'waiting_payment' },
        { text: this.$t('order.confirmed'), value: 'confirmed' },
        { text: this.$t('order.partiallyConfirmed'), value: 'partially_confirmed' },
        { text: this.$t('order.toPickup'), value: 'to_pickup' },
        { text: this.$t('order.shippingInProgress'), value: 'shipping_in_progress' },
        { text: this.$t('order.partialShippingInProgress'), value: 'partial_shipping_in_progress' },
        { text: this.$t('order.delivered'), value: 'delivered' },
        { text: this.$t('subOrder.waitingAllocation'), value: 'waiting_allocation' },
        { text: this.$t('order.deliveredPartially'), value: 'partially_delivered' },
        { text: this.$t('order.waitingCarrier'), value: 'waiting_carrier' },
        { text: this.$t('order.cancelled'), value: 'cancelled' },
        { text: this.$t('order.blocked'), value: 'blocked' },
      ],
      orderTypeTranslations: [
        { text: this.$t('subOrder.shipFromWarehouse'), value: 'ship_from_warehouse' },
        { text: this.$t('subOrder.clickAndCollect'), value: 'click_and_collect' },
        { text: this.$t('subOrder.inStorePickup'), value: 'in_store_pickup' },
        { text: this.$t('subOrder.shipFromStore'), value: 'ship_from_store' },
        { text: this.$t('subOrder.clickAndReserve'), value: 'click_and_reserve' },
        { text: this.$t('subOrder.interStore'), value: 'inter_store' },
        { text: this.$t('order.homeDelivery'), value: 'home_delivery' },
        { text: this.$t('order.storeDelivery'), value: 'store_delivery' },
        { text: this.$t('order.relayPointDelivery'), value: 'relay_point_delivery' },
        { text: this.$t('order.expressHomeDelivery'), value: 'express_home_delivery' },
      ],
      cancelReasons: [
        { text: this.$t('subOrder.clientChangeOfMind'), value: 'client_changed_his_mind' },
        { text: this.$t('subOrder.deterioratedProducts'), value: 'deteriorated_products' },
        { text: this.$t('subOrder.orderedMultipleTimes'), value: 'ordered_multiple_times' },
        { text: this.$t('subOrder.productsNotAvailable'), value: 'products_not_available' },
        { text: this.$t('subOrder.timeout'), value: 'timeout' },
        { text: this.$t('subOrder.customerDidNotCollect'), value: 'customer_did_not_collect_order' },
        { text: this.$t("subOrder.customerDidNotCollectHisReservation"), value: "customer_did_not_collect_his_reservation" },
        { text: this.$t('subOrder.otherReason'), value: 'other' },
      ],
      targetItem: undefined
    }
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    isSubOrder:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSuborder() {
      return this.order.source_order_id ? true : false
    },
    totalNbProduct: function () {
      return this.getNbProducts(this.order.items)
    },
    totalNbProductValidated: function () {
      return this.getNbProductsValidated(this.order.items)
    },
    stackHeaders() {
      return this.$vuetify.breakpoint.width < 500
    },
    totalPriceValidated: function () {
      let totalPriceValidated = 0
      for (let item of this.order.items) {
        if (item.validated_quantity) {
          totalPriceValidated += item.validated_quantity * item.product_sale_price
        }
      }
      return totalPriceValidated
    },
    isPaid: function () {
      let paidAmount = 0
      if (this.order.payments && this.order.payments.length > 0) {
        for (let i = 0; i < this.order.payments.length; i++) {
          if (this.order.payments[i].payment_amount) {
            paidAmount += this.order.payments[i].payment_amount
          }
        }
      }
      console.log(paidAmount)
      if (
        this.order.type == 'click_and_reserve' &&
        ['delivered', 'partially_delivered'].includes(this.order.current_status)
      ) {
        return true
      } else if (paidAmount == 0) {
        return false
      }
      // the second condition's member is to check if there was a reduction on the whole basket and not on products
      else if (this.order.current_status == 'waiting' || this.order.total_price < this.totalPriceValidated) {
        return paidAmount >= this.order.total_price
      } else {
        return paidAmount >= this.totalPriceValidated
      }
    },
  },
  methods: {
    openHistoryDialog: function (item) {
      this.showHistoryDialog = true
      this.targetItem = item
    },
    closeHistoryDialog: function () {
      this.showHistoryDialog = false
    },
    getStatusTranslation: function (statusValue) {
      let status = this.status.find((status) => status.value == statusValue)
      if (status) {
        return status.text
      } else return statusValue
    },
    getTypeTranslation: function (typeValue) {
      let type = this.orderTypeTranslations.find((type) => type.value == typeValue)
      if (type) {
        return type.text
      } else return typeValue
    },
    getCancelReasonTranslation: function (cancelReasonValue) {
      /*
       *  These cancel reason translations are added here because these reasons
       *  are not part of the cancel reason list that can be picked by the user
       */
      if (cancelReasonValue == 'partial_not_authorized') {
        return this.$t('subOrder.partialNotAuthorized')
      } else if (cancelReasonValue == 'no_product_validated') {
        return this.$t('subOrder.noProductValidated')
      } else if (cancelReasonValue == 'no_product_bought') {
        return this.$t('subOrder.noProductBought')
      }
      let cancelReason = this.cancelReasons.find((cancelReason) => cancelReason.value == cancelReasonValue)
      if (cancelReason) {
        return cancelReason.text
      } else return cancelReasonValue
    },
    getCarrierCost() {
      let carrier = this.order.carrier
      return carrier && carrier.cost ? carrier.cost : 0
    },
    getNbProducts: function (orderItems) {
      let totalNbProduct = 0
      for (let productLine of orderItems) {
        totalNbProduct += productLine.product_quantity
      }
      return totalNbProduct
    },
    getNbProductsValidated: function (orderItems) {
      let nbProduct = 0
      for (let productLine of orderItems) {
        if (productLine.validated_quantity) {
          nbProduct += productLine.validated_quantity
        }
      }
      return nbProduct
    },
  },
}
</script>
